import get from 'lodash/get'
import Path from 'webmango-utils/path'

import * as selfExports from './infiledata'

export default function InfileData (props) {
  return Object.assign({},
    outputGlobalConfig(props),
    outputRunSections(props)
  )
}

export {
  outputValue,
  outputNodeValue,
  outputGlobalConfig
}

Object.assign(InfileData, selfExports)

function outputValue (props) {
  let { schema, value, config, sample } = props
  const node = { value }
  return outputNodeValue({ node, schema, config, sample })
}

function outputNodeValue (props) {
  const { node, schema, sample, config } = props
  return schema.properties.reduce((out, property) => {
    if (!property.name) throw new Error('no property name')
    if (property.isSection) {
      return Object.assign(out, {
        [property.name]: outputNodeValue(Object.assign({}, props, {
          schema: property
        }))
      })
    } else if (property.isList) {
      const value = get(node.value, property.path.join('/'), property.default)
      const selectedItem = property.properties.find(p => p.condition === value)
      return Object.assign(out, {
        [property.name]: value
      }, (selectedItem && {
        [selectedItem.name]: outputNodeValue(Object.assign({}, props, {
          schema: selectedItem
        }))
      }) || {})
    } else if (property.isMultiValue) {
      let value = get(node.value, property.path.join('/'), property.default)
      const KEYS = 'xyza'.split('')
      value = value.reduce((out, childValue, index) => {
        if (property.childType === 'double') childValue = parseDouble(childValue)
        return Object.assign(out, {
          [`${property.name}_${KEYS[index]}`]: childValue
        })
      }, {})

      return Object.assign(out, value)
    } else {
      let value = get(node.value, property.path.join('/'), property.default)
      // make files absolute paths
      if (property.type === 'file') {
        value = Path.join(config.root, Path.resolve(sample.localSamplePath, value))
      }

      if (property.type === 'multi_string') {
        // wrap in array to signal type is multi_string
        value = [value]
      }

      // ensure doubles include decimal point
      if (property.type === 'double') {
        value = parseDouble(value)
      }

      return Object.assign(out, {
        [property.name]: value
      })
    }
  }, {})
}

function parseDouble (value) {
  return Number.isInteger(value)
    ? String(value) + '.0'
    : String(value)
}

/**
 * Global Config Handling
 */

function outputGlobalConfig (props) {
  let { globalConfigSchema, globalConfig, sample, config } = props
  const out = outputValue({
    schema: globalConfigSchema,
    value: globalConfig,
    config
  })
  return reorderGlobalConfigProperties(removeGlobalConfigPaths({
    globalConfig: out,
    sample
  }))
}

function removeGlobalConfigPaths ({ globalConfig, sample }) {
  // Logic taken from qmango ActionPanel::save in ActionPanel.c
  globalConfig.working_directory = globalConfig.remote_working_directory
  delete globalConfig.local_working_directory
  delete globalConfig.remote_working_directory
  delete globalConfig.current_machine
  return globalConfig
}

function reorderGlobalConfigProperties (globalConfig) {
  globalConfig.MPI = Object.assign({
    num_processors: globalConfig.MPI.num_processors
  }, globalConfig.MPI)
  return globalConfig
}

function outputRunSections (props) {
  const { runSections, nodes, schemas } = props
  const nodeIDs = Object.keys(runSections)
    .slice(1) // ignore input node

  return nodeIDs.reduce((out, nodeID, index) => {
    const node = nodes.find(n => n.id === nodeID)
    const runSection = runSections[nodeID]
    const schema = schemas[node.schemaID]
    const runIndex = index + 1
    const runKey = `Run_${String(runIndex).length < 2 ? '0' + runIndex : runIndex}`
    return Object.assign(out, {
      [runKey]: Object.assign({}, runSection, {
        [schema.name]: outputNodeValue(Object.assign({
          node,
          schema
        }, props))
      })
    })
  }, {})
}



// WEBPACK FOOTER //
// ../webmango-core/infiledata.js